import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import {
  DndColumns,
  NO_PREVIEW,
} from 'components/Wizards/CustomObject/steps/CustomLayout/dialogs/LayoutComponentWizard/subsections/RelatedObjectFields/DnDColumns';
import { CONTEXTS } from 'components/Wizards/utils';
import { useMemo, useState } from 'react';

const StyledDndColumns = styled(DndColumns)`
  min-height: calc(100vh - 430px);
  & > div {
    margin-top: 8px;
  }
`;

const dummyFn = () => false;

const getRightItems = (selectedColumns) => {
  return selectedColumns.map(({ label, value }) => {
    return {
      label,
      id: value,
    };
  });
};

const getLeftItems = (groupedOptions, rightItems) =>
  groupedOptions.flatMap(({ id, label, options }) => {
    const fieldOptions = options.reduce((acc, option) => {
      const rightItem = rightItems.find((el) => el.id === option.value);
      if (!rightItem) {
        return acc.concat({
          label: option.label,
          id: option.value,
        });
      }
      return acc;
    }, []);
    return fieldOptions.length
      ? [{ label, id, isGroupedItem: true }].concat(fieldOptions)
      : [];
  });

const getLeftColumnOrdering = (groupedOptions) =>
  groupedOptions.flatMap(({ options, id }) => {
    return [id].concat(options.map(({ value }) => value));
  });

export const DraggableExportColumns = ({
  selectedFields,
  fieldOptions,
  onChange,
}) => {
  const { t } = useTranslation();

  const [rightItems] = useState(() => getRightItems(selectedFields));

  const leftItems = useMemo(
    () => getLeftItems(fieldOptions, rightItems),
    [fieldOptions, rightItems]
  );

  const itemsOrdering = useMemo(
    () => getLeftColumnOrdering(fieldOptions),
    [fieldOptions]
  );

  return (
    <StyledDndColumns
      initialLeftColumnItems={leftItems}
      initialRightColumnItems={rightItems}
      searchPlaceholder={t('Find Options')}
      headerPreviewComponent={NO_PREVIEW}
      leftHeaderText={t('Available Columns (Drag to Add)')}
      rightHeaderText={t('Selected Columns')}
      renderRightEmpty={{
        onDropLabel: t('Place Here'),
        noItems: t('No Columns Currently Selected (Drag and Drop to Add)'),
      }}
      renderLeftEmpty={{
        onDropLabel: t('Drop to Remove'),
        noItems: t('No Columns Found'),
      }}
      onChange={onChange}
      iconVisible={dummyFn}
      iconEditable={dummyFn}
      colorEditable={dummyFn}
      context={CONTEXTS.fields}
      showCategoryOnSearch={false}
      grouped
      itemsOrdering={itemsOrdering}
    />
  );
};
